let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("atleV")).then(() => parcelRequire('kuN8H'));